<template>
  <div class="activity-report">
    <div class="activity-report-content">
      <Row>
          <Col
            span="8"
            v-for="(item, index) in [1,1,1,1]"
            :key="index"
            class="w-20"
          >
            <div class="report-list">
              <div class="report-list-l">
                <div class="p-1">
                  <p>姓名姓名姓名姓名姓名姓名姓名姓名姓名姓名姓名姓名姓名姓名</p>
                  <span>经理</span>
                </div>
                <p class="p-2">联展软件</p>
                <p class="p-3">18888888888</p>
                <p class="p-4">描述</p>
              </div>
              <div class="report-list-r">
                <img src="https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJYqUhV9sVc7h5ex2JLwcM8WZlZsVpyoDyOvxquvB0wr6J5NK0ExVGDoQ8J5IjwGiaknE72HySx5yA/132">
              </div>
            </div>
          </Col>
        </Row>
    </div>
  </div>
</template>

<script>
export default {
  name: "host-activity-report",
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.activity-report {
  margin: 30px;
  min-width: 800px;
  &-content {
    .report-list {
      background-color:#fff;
      margin: 0 15px 30px;
      height: 148px;
      padding: 20px;
      display: flex;
      &-l {
        width: 80%;
        .p-1 {
          width: 100%;
          margin: 5px 0;
          font-size: 16px;
          color: #333;
          display: flex;
          align-items: center;
          p {
            max-width: 60%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          span {
            color: #8c8c8c;
            font-size: 12px;
            margin-left: 5px;
          }
        }
        .p-2 {
          color: #8c8c8c;
          font-size: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .p-3 {
          margin: 5px 0;
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #333;
        }
        .p-4 {
          color: #ccc;
          font-size: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      &-r {
        width: 60px;
        height: 100%;
        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>